export default {
    getNoticeListBySender: '/notice/getNoticeListBySender', //获取通知列表
    saveNotice: '/notice/saveNotice', //存草稿
    sendNotice: '/notice/sendNotice', //发送通知
    getDetailsById: '/notice/getDetailsById/{noticeId}', //获取通知详情
    getOrganization: '/notice/getOrganization', //获取组织架构
    sendNoticeAgain: '/notice/again/send/{noticeId}',//重新发送通知
    deleteNotice: "/notice/delete/{noticeId}",//删除通知
}


// WEBPACK FOOTER //
// ./src/api/config/notice.js